import type { ReactNode } from 'react';

interface PageProps {
  title: string;
  /** Texto corto bajo el titulo. */
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function Page({ title, subtitle, action, children }: PageProps) {
  return (
    <div className="mx-auto w-full max-w-lg px-4 pb-4">
      <header className="flex items-end justify-between gap-3 py-4">
        <div className="min-w-0">
          <h1 className="truncate text-2xl font-bold tracking-tight">{title}</h1>
          {subtitle ? (
            <p className="mt-0.5 text-sm text-[var(--color-text-muted)]">{subtitle}</p>
          ) : null}
        </div>
        {action}
      </header>
      {children}
    </div>
  );
}

export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-[var(--radius-card)] border border-dashed border-[var(--color-border)] px-6 py-10 text-center">
      {icon ? <div className="text-[var(--color-text-muted)]">{icon}</div> : null}
      <p className="font-medium">{title}</p>
      {hint ? <p className="max-w-xs text-sm text-[var(--color-text-muted)]">{hint}</p> : null}
      {action}
    </div>
  );
}
